export enum eTypeData {
  Numérico = 1,
  Alfanumérico = 2
}
